export var SearchModeEnum;
(function (SearchModeEnum) {
    SearchModeEnum[SearchModeEnum["NUMBER_0"] = 0] = "NUMBER_0";
    SearchModeEnum[SearchModeEnum["NUMBER_1"] = 1] = "NUMBER_1";
    SearchModeEnum[SearchModeEnum["NUMBER_2"] = 2] = "NUMBER_2";
})(SearchModeEnum || (SearchModeEnum = {}));
SearchModeEnum['NUMBER_0'] = 0;
SearchModeEnum['NUMBER_1'] = 1;
SearchModeEnum['NUMBER_2'] = 2;
//# sourceMappingURL=searchModeEnum.js.map